<template>
  <label class="pfradio" :class="{'pfradio_disabled':disabled, 'pfradio_withimage':image}" >
    <div class="pfradio__image" v-html="image" v-if="image">
    </div>
    <input type="radio" :name="name" v-model="val" :value="inputvalue" :required="required?'required':false" :disabled="disabled">
    <div class="pfradio__dot" tabindex="0" @keypress.enter.space="$el.click()"></div>
    <span class="pfradio__text">{{text}}</span>
  </label>
</template>

<script>
  export default {
    props: {
      name: {type: String, required: true},
      image: {type: String, default: ''},
      required: {type: Boolean},
      inputvalue: {type: String, required: true},
      text: {type: String, required: true},
      modelValue: {type: String},
      disabled: { type: Boolean, default: false },
    },
    computed: {
      val:{
        get(){
          return this.modelValue
        },
        set(v){
          this.$emit('update:modelValue', v)
        },
      }
    }
  }
</script>

<style lang="sass">
.radiogroup__content_grid-inc-3
  @include for-mob
    .pfradio__image svg
      width: 64px
      height: 64px
.pfradio
  display: flex
  align-items: flex-start
  cursor: pointer
  color: colors.$bluefont5b
  font-size: 16px 
  line-height: 26px
  min-width: 127px
  letter-spacing: globalvars.$onespacing
  &_withimage
    padding-right: 0
    display: flex
    flex-direction: column
    align-items: center
    text-align: center
    font-size: 18px
    line-height: 1.12
    min-width: initial
    .pfradio__dot
      margin: 15px 0 0
      margin-right: 0
      order: 1
      @include for-mob
        margin: 4px 0 0
  &__image
    margin-bottom: 17px
    @include for-mob
      margin-bottom: 4px
    svg
      display: block
      width: 120px
      height: 120px


  &_disabled
    cursor: auto
  input
    display: none
  input:checked + &__dot
    border-color: colors.$gray7
    &::after
      content: ''
  &__dot
    flex-shrink: 0
    width: 24px
    height: 24px
    margin-right: 16px
    border-radius: 50%
    border: 2px solid colors.$btngray
    display: flex
    align-items: center
    justify-content: center
    &::after
      display: block
      background: colors.$red
      width: 12px 
      height: 12px
      border-radius: 50%
      
.pfslide_5 .pfradio__image svg
  @include from(1400px)
    width: 80px
    height: 80px 
  @include for-mob
    width: 48px
    height: 48px
  
</style>